import {FC} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {useHistory} from 'react-router'

import {Box, Skeleton, Typography} from '@mui/material'
import Dinero from 'dinero.js'
import {makeStyles} from 'tss-react/mui'

import {ReactComponent as EligibleMemberIllu} from '@progyny/assets/images/eligible-member-illu.svg'
import SubmitButton from '@progyny/components/Buttons/SubmitButton'
import {RouteEnum, useRoutes} from '@progyny/routes'
import {useMeStore} from '@progyny/store/meStore'
import {hideZeroCents} from '@progyny/utils/dinero'

const useStyles = makeStyles()(() => ({
  container: {
    maxWidth: 430,
  },
  companyName: {
    textTransform: 'capitalize',
  },
}))

const MemberPromotion: FC = () => {
  const {t} = useTranslation()
  const user = useMeStore((s) => s.user)
  const setMyLocale = useMeStore((s) => s.setMyLocale)
  const loading = useMeStore((s) => s.loading)
  const {classes} = useStyles()
  const history = useHistory()
  const {getPath} = useRoutes()

  if (loading || !user) {
    return <Skeleton variant='rectangular' width={'100%'} height={200} />
  }
  const companyBudget = setMyLocale(
    Dinero(user.member?.contract?.budgetPerMember as Dinero.Options)
  )

  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      className={classes.container}
      flexDirection={'column'}
      mt={14}
      mx={'auto'}
    >
      <Box mb={6}>
        <EligibleMemberIllu />
      </Box>
      <Box>
        <Box mb={3}>
          <Typography variant={'h3'} fontWeight={400}>
            <Trans i18nKey='home_member_promotion_you_are_now_eligible_member' />
          </Typography>
        </Box>
        <Box mb={5}>
          <Typography variant={'body1'}>
            You can now use the full potential of Progyny Benefits.{' '}
            <strong>{user.company?.name}</strong> is providing reimbursement for
            100% of your supported fertility and adoption expenses up to{' '}
            {hideZeroCents(companyBudget)}. This includes your spouse or
            domestic partner.
          </Typography>
        </Box>
        <Box
          textAlign={'center'}
          onClick={() => history.push(getPath(RouteEnum.HOME))}
        >
          <SubmitButton>
            {t('home_member_promotion_go_to_startpage')}
          </SubmitButton>
        </Box>
      </Box>
    </Box>
  )
}

export default MemberPromotion
